module.exports = __webpack_public_path__ + "static/media/capa-manager-mobile.37906c1d.png";